import React, { ComponentProps } from 'react'
import Group from 'components/utils/Group'

type Props = Omit<ComponentProps<typeof Group>, 'direction' | 'gap' | 'noDisplayWhenEmpty'>

function LabelGroup(props: Props) {
  return <Group
    {...props}
    direction="horizontal"
    gap={4}
    wrap={props.wrap ?? 'wrap'}
    noDisplayWhenEmpty
    verticalAlign="center"
  />
}

export default LabelGroup
